// When a hover card is open (components/HoverCard.tsx), as one pure function so node --test can
// check it without a DOM. The component feeds it events; the delays live in the component.

export type HoverCardEvent =
  | 'hover_settled'   // the pointer rested on the trigger for the open delay
  | 'pointer_left'    // the pointer left the trigger and the card, after the close delay
  | 'focus'           // keyboard focus reached the trigger
  | 'blur'            // focus left the trigger
  | 'activate'        // Enter or Space on the trigger, or a tap
  | 'escape'          // Escape, anywhere while open
  | 'outside_press';  // a press outside the trigger and the card

// `pinned` is the dev-only `?hover=` pin: nothing closes it.
export function nextHoverCardOpen(open: boolean, event: HoverCardEvent, pinned = false): boolean {
  if (pinned) return true;
  switch (event) {
    case 'hover_settled':
    case 'focus':
      return true;
    case 'activate':
      return !open;
    case 'pointer_left':
    case 'blur':
    case 'escape':
    case 'outside_press':
      return false;
  }
  return open;
}

// Keys the trigger handles itself and keeps from the row underneath: Enter and Space would
// open the account panel, and j / k would move the row selection out from under the card.
export const TRIGGER_KEYS = new Set(['Enter', ' ', 'j', 'k']);
